import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneWaveOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.187 8.829c.85.85 1.564 1.35 2.013 1.62.319.192.705.188 1.045.039l2.007-.878L16 12.215c-1.736 6.13-7.335 3.954-11.745-.455C-.156 7.351-2.356 1.732 3.78 0l2.607 3.746-.868 2.03c-.144.338-.146.72.043 1.034.27.449.771 1.165 1.625 2.019M4.232 5.227l.563-1.318-1.557-2.236C2.49 2 2.048 2.386 1.792 2.75c-.335.479-.472 1.095-.346 1.912.266 1.731 1.666 3.975 3.798 6.107s4.371 3.524 6.096 3.786c.813.123 1.428-.014 1.907-.351.365-.257.75-.7 1.08-1.448l-2.23-1.55-1.29.563c-.675.296-1.55.348-2.329-.121-.543-.327-1.347-.897-2.28-1.83-.939-.938-1.51-1.745-1.836-2.288-.463-.77-.416-1.635-.13-2.304"
                    fill="currentColor"
                />
                <path
                    d="M9.685 1.618a6.61 6.61 0 0 1 4.693 4.693l1.383-.247A8.01 8.01 0 0 0 9.93.235z"
                    fill="currentColor"
                />
                <path
                    d="M9.474 2.797A5.01 5.01 0 0 1 13.2 6.522l-1.381.246a3.6 3.6 0 0 0-2.59-2.59z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneWaveOutlinedSize16Glyph.displayName = 'PhoneWaveOutlinedSize16Glyph';
